
      <form [formGroup]="form" class="d-flex flex-column custom-modal-content">
        <div class='my-5 mx-auto'>
          <app-input-field *ngFor='let el of fieldObjects' [parentForm]='form' [inputJson]='el'>
          </app-input-field>
        </div>
      </form>
